import { useTranslation } from "react-i18next";

import { usePaidAccess } from "entities/subscription";
import { WarningBanner } from "shared/ui";

import { LinkToCustomerPortal } from "./link-to-customer-portal";

interface PaymentFailedBannerProps {
  /** Where the banner sits, for the billing-portal analytics event. */
  source: string;
  className?: string;
}

/** Asks a broker whose payment failed to update their card. Renders nothing otherwise. */
export function PaymentFailedBanner({
  source,
  className,
}: PaymentFailedBannerProps) {
  const { t } = useTranslation("common");
  const { needsPaymentUpdate } = usePaidAccess();

  if (!needsPaymentUpdate) return null;

  return (
    <WarningBanner className={className}>
      {t("paymentFailedBanner.message")}{" "}
      <LinkToCustomerPortal source={source} className="font-semibold underline">
        {t("paymentFailedBanner.action")}
      </LinkToCustomerPortal>
    </WarningBanner>
  );
}
